import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Navbar from "../../components/AppHeader/AppHeader.component";
import Login from "../../pages/Login";
import ChangePassword from "../../pages/ChangePassword";
import ContractsContainer from "../Contracts/Contracts.container";
import ContractDetailsContainer from "../ContractDetails/ContractDetails.container";
import CompaniesContainer from "../Companies/Companies.container";
import CompanyDetailsContainer from "../CompanyDetails/CompanyDetails.container";
import { AuthRoute, ProtectedRoute } from "../../helpers/utils/route";
import AppSnackBar from "../../components/AppSnackBar/AppSnackBar.component";
import "../../i18n";
import { Grid } from "@material-ui/core";
import "./App.css";
import Modal from "../../components/Modal";

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <div className="root-container">
          <Switch>
            <Route exact path="/">
              <Redirect to="/login" />
            </Route>
            <AuthRoute path="/login" component={Login} />
            <ProtectedRoute
              path="/change_password"
              component={ChangePassword}
            />
            <ProtectedRoute path="/contracts" component={ContractsContainer} />
            <ProtectedRoute
              path="/contract"
              component={ContractDetailsContainer}
            />
            <ProtectedRoute path="/companies" component={CompaniesContainer} />
            <ProtectedRoute
              path="/company"
              component={CompanyDetailsContainer}
            />
          </Switch>
        </div>

        <AppSnackBar />
        <Modal />
      </div>
    </Router>
  );
}

export default App;
